export default __webpack_public_path__ + "static/media/Monk's Gloves of the Black Thread.bbf0daa2.jpg";